module.exports = __webpack_public_path__ + "static/media/video-placeholder_whatis.e693b6a7.png";